export enum Comunications {
  FILES = 0,
  SENDS = 1,
  EXTERNALS = 2,
  //Alerts = 3,
  PROCEDURES = 3
}
